import { createFileRoute } from '@tanstack/react-router'
import { ComplianceProfileSettings } from '@/features/organizations/settings/compliance-profile'

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/compliance-profile'
)({
  component: ComplianceProfileSettings,
})
